import {createApp} from 'vue'
import {createPinia} from 'pinia'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale-subtle.css'
import '../styles/style.scss'
import 'highlight.js/styles/atom-one-dark.css'
import '@toolify/client/src/modules/theme/strategies/dark/dark-theme.scss'
import '@toolify/client/src/modules/theme/strategies/light-modern/light-modern-theme.scss'
import '@toolify/client/src/modules/theme/strategies/fiord-night/fiord-night-theme.scss'
import '@toolify/client/src/styles/colors.scss'
import App from './App.vue'
import {setupClientRoutes} from './router/setupClientRoutes'
import {setupRouter} from './router/setupRouter'
import {runPostClientSetupTasks} from './runPostClientSetupTasks'
import {setupVuePlugins} from '@toolify/client/src/setup/setupVuePlugins'
import CKEditor from '@ckeditor/ckeditor5-vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import localforage from 'localforage'
import {startRootStyleObserver} from '@toolify/client/src/composables/useRem'
import {registerFontAwesomeIcons} from './registerFontAwesomeIcons'

if (typeof window !== 'undefined') {
  window.localforage = localforage
}

startRootStyleObserver()
registerFontAwesomeIcons()

const vueApp = createApp(App)

vueApp.component('FontAwesomeIcon', FontAwesomeIcon)

const pinia = createPinia()
vueApp.use(pinia)

const routes = setupClientRoutes(pinia)
const router = setupRouter(routes)

vueApp.use(router)

vueApp.use(CKEditor)

setupVuePlugins(vueApp)

runPostClientSetupTasks(
  router,
  pinia,
  vueApp,
)

vueApp.mount('#app')
